var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"back-button",on:{"click":_vm.goBack}},[_vm._v(" ← ")])
}
var staticRenderFns = []

export { render, staticRenderFns }